import axios from "axios";

import { API_BASE_PATH } from "./../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const frameworkParams = (productId, extra = {}) => {
  const temp = getUserDetails();
  return {
    companyId: temp.companyid,
    productId: productId || 0,
    ...extra,
  };
};

export const getFrameworkStatus = async (productId) => {
  const response = await axios.get(`${API_BASE_PATH}/KeyLogging/framework/status`, {
    params: frameworkParams(productId),
  });
  return response.data;
};

export const getFrameworkRecipe = async (productId) => {
  const response = await axios.get(`${API_BASE_PATH}/KeyLogging/framework/recipe`, {
    params: frameworkParams(productId),
  });
  return response.data;
};

export const uploadFrameworkZip = async (productId, file, platform, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  const response = await axios.post(`${API_BASE_PATH}/KeyLogging/framework/upload`, form, {
    params: frameworkParams(productId, platform ? { platform } : {}),
    onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded * 100) / e.total) : 0),
  });
  return response.data;
};

export const connectFrameworkGit = async (
  productId,
  { repoUrl, branch, gitUsername, gitToken, platform },
) => {
  const params = new URLSearchParams();
  Object.entries({ repoUrl, branch, gitUsername, gitToken, platform }).forEach(([k, v]) => {
    if (v) params.append(k, v);
  });
  const response = await axios.post(`${API_BASE_PATH}/KeyLogging/framework/git`, params, {
    params: frameworkParams(productId),
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
};

export const rebuildFramework = async (productId) => {
  const response = await axios.post(`${API_BASE_PATH}/KeyLogging/framework/rebuild`, null, {
    params: frameworkParams(productId),
  });
  return response.data;
};

export const deleteFramework = async (productId) => {
  const response = await axios.delete(`${API_BASE_PATH}/KeyLogging/framework`, {
    params: frameworkParams(productId),
  });
  return response.data;
};

export const apiError = (err, fallback) =>
  err?.response?.data?.error || err?.response?.data?.message || err?.message || fallback;
